<template>
  <div class="menu-plans-v5">
    <div class="day-selector-v5__title">
      Ваша программа питания
    </div>
    <div
      v-if="plans.length === 2"
      class="menu-plans-v5__plans menu-plans-v5__two-plans-flow"
    >
      <menu-plan
        v-for="(item, index) in plans"
        :key="'menu-plans'+index"
        :is-active="index === activeIndex"
        @click="setActive(index)"
      >
        <template #name>
          {{ item.title }}
        </template>
        <template #title>
          <span v-if="!isRevert">
            {{ $formatMoney(item.kcal) }} Ккал
          </span>
          <span v-else>
            {{ getDesc(item) }}
          </span>
        </template>
        <template #subtitle>
          <span v-if="!isRevert">
            {{ item.pricePlan.realNumberOfMeals }} {{ $numberLingFormFunc(item.pricePlan.realNumberOfMeals, 'прием', 'приема', 'приемов') }}
          </span>
          <span v-else>
            {{ item.pricePlan.realNumberOfMeals }} {{ $numberLingFormFunc(item.pricePlan.realNumberOfMeals, 'блюдо', 'блюда', 'блюд') }}
          </span>
        </template>
      </menu-plan>
    </div>
    <swiper
      v-else-if="plans.length > 0"
      ref="menuSlider"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :centered-slides-bounds="true"
      :update-on-window-resize="false"
      class="menu-plans-v5__plans menu-plans-v5__swiper"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="(item, index) in plans"
        :key="'menu-plans'+index"
        class="menu-plans-v5__slide"
      >
        <menu-plan
          :is-active="index === activeIndex"
          @click="setActive(index)"
        >
          <template #name>
            {{ item.title }}
          </template>
          <template #title>
            <span v-if="!isRevert">
              {{ $formatMoney(item.kcal) }} Ккал
            </span>
            <span v-else>
              {{ getDesc(item) }}
            </span>
          </template>
          <template #subtitle>
            <span v-if="!isRevert">
              {{ item.pricePlan.realNumberOfMeals }} {{ $numberLingFormFunc(item.pricePlan.realNumberOfMeals, 'прием', 'приема', 'приемов') }}
            </span>
            <span v-else>
              {{ item.pricePlan.realNumberOfMeals }} {{ $numberLingFormFunc(item.pricePlan.realNumberOfMeals, 'блюдо', 'блюда', 'блюд') }}
            </span>
          </template>
        </menu-plan>
      </swiper-slide>
    </swiper>
    <swiper
      v-else
      ref="menuSlider"
      class="menu-plans-v5__swiper"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :centered-slides-bounds="true"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="item in 3"
        :key="item"
        class="menu-plans-v5__slide"
      >
        <menu-plan skeleton>
          <template #name>
            <span
              class="skeleton-box radius skeleton__plan-name-content "
            />
          </template>
          <template #title>
            <span v-if="!isRevert">
              <span
                class="skeleton-box radius skeleton__plan-title-content"
              />
            </span>
            <span v-else>
              <span
                class="skeleton-box radius skeleton__plan-title-content"
              />
            </span>
          </template>
          <template #subtitle>
            <span v-if="!isRevert">
              <span
                class="skeleton-box radius skeleton__plan-name-content "
              />
            </span>
            <span v-else>
              <span
                class="skeleton-box radius skeleton__plan-name-content "
              />
            </span>
          </template>
        </menu-plan>
      </swiper-slide>
    </swiper>
    <div class="menu-plans-v5__info">
      <div class="menu-plans-v5__info-title">
        Месяц без повторов
      </div>
      <div class="menu-plans-v5__info-desc">
        Настроить предпочтения или заменить блюда можно после оформления заказа
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/swiper-vue'
import MenuPlan from './MenuPlan.vue'
import { mapActions } from 'vuex'

export default {
  name: 'MenuPlansV5',
  components: {
    Swiper,
    SwiperSlide,
    MenuPlan,
  },
  props: {
    plans: {
      type: Array,
      default: () => [],
    },
    // определяет отображение параметров, если выбрана цель "Еду на каждый день" то отображать по другому
    isRevert: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:value'],
  data () {
    return {
      mySwiper: null,
    }
  },
  computed: {
    activeIndex () {
      if (!this.value) {
        return 0
      }
      return this.plans.findIndex((item) => {
        return this.value.id === item.id
      })
    },
  },
  watch: {
    activeIndex () {
      setTimeout(() => {
        this.mySwiper.slideTo(this.activeIndex, 300)
      }, 0)
    },
    plans () {
      setTimeout(() => {
        this.mySwiper.slideTo(this.activeIndex, 300)
      }, 0)
    },
  },
  mounted () {
    if (this.mySwiper) {
      setTimeout(() => {
        this.mySwiper.slideTo(this.activeIndex, 300)
      }, 0)
    }
  },
  methods: {
    ...mapActions({
      firebasePerformanceCustomTraceStart: 'analytics/firebasePerformanceCustomTraceStart',
    }),
    getDesc (item) {
      return item?.webShortDescription ? item.webShortDescription : `${this.$formatMoney(item.kcal)} Ккал`
    },
    setSwiper (swiper) {
      this.mySwiper = swiper
    },
    setActive (index) {
      this.firebasePerformanceCustomTraceStart('menuChanging')
      this.$emit('update:value', this.plans[index])
    },
  },
}
</script>

<style lang="scss">
.menu-plans-v5 {
  margin: -0.16rem auto .12rem;
  width: 100%;
  padding: .16rem;
  overflow: hidden;
  background: map-get($colors, 'white');
  &__title {
    margin-bottom: .16rem;
    color: var(--main-black, #0D0D0D);
    font-size: 0.2rem;
    font-style: normal;
    font-weight: 600;
    line-height: 0.24rem; /* 120% */
  }
  &__plans {
    margin-bottom: .12rem;
  }
  &__swiper {
    overflow: visible !important;
    padding-top: .06rem !important;
    padding-bottom: 0.01rem !important;
  }

  &__slide {
    width: 1.44rem !important;
  }
  &__info {
    padding: 0.12rem 0.16rem;
    border-radius: 0.16rem;
    background: var(--greyscale-grey-4, #F5F5F5);
    color: var(--greyscale-grey-60, #666);
  }
  &__info-title {
    font-size: 0.14rem;
    font-style: normal;
    font-weight: 600;
    line-height: 0.18rem; /* 128.571% */
    margin-bottom: .04rem;
  }
  &__info-desc {
    font-size: 0.12rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  &__two-plans-flow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0.04rem 0 0 0;
    margin: 0 -0.04rem;
  }
}

</style>
